// ProtectedRoute.js
import React from "react";
import { Navigate } from "react-router-dom";

function ProtectedRoute({ element }) {
  const token = typeof window !== "undefined" ? localStorage.getItem("access_token") : null;
  if (!token) {
    return <Navigate to="/" replace />;
  }
  return element;
}

export default ProtectedRoute;
